export var SelectionType = {
    MIXED: 1,
    REGULAR: 2,
    OVERLAYED: 3
};
